module.exports = __webpack_public_path__ + "img/4@2x.19ea5aed.png";